/**
 * Navigation Configuration
 * 사이드바 네비게이션 메뉴 설정
 */

export interface NavSubItem {
    id: string;
    label: string;
    page?: string;  // page가 없으면 하위 메뉴가 있는 것
    children?: NavSubItem[];  // 3단계 메뉴
    disabled?: boolean;  // 메뉴 비활성화 여부
}

export interface NavItem {
    id: string;
    label: string;
    icon: string;
    submenu?: NavSubItem[];
}

export const NAV_ITEMS: NavItem[] = [
    {
        id: 'dashboard',
        label: '대시보드',
        icon: 'fa-tachometer-alt',
        submenu: [
            { id: 'dashboard_main', label: '대시보드', page: 'dashboard' },
        ],
    },
    {
        id: 'notice',
        label: '공지사항',
        icon: 'fa-bullhorn',
        submenu: [
            { id: 'notice_management', label: '공지 관리', page: 'notice_management' },
        ],
    },
    {
        id: 'rider',
        label: '라이더',
        icon: 'fa-motorcycle',
        submenu: [
            { id: 'rider_status', label: '라이더 현황', page: 'rider_status' },
            { id: 'delivery_history', label: '배달 내역 조회', page: 'delivery_history' },
            { id: 'delivery_history_detail', label: '배달 상세 내역 조회', page: 'delivery_history_detail' },
        ],
    },
    {
        id: 'partner',
        label: '협력사',
        icon: 'fa-building',
        submenu: [
            { id: 'partner_status', label: '협력사 현황', page: 'partner_status' },
            {
                id: 'partner_fee',
                label: '협력사 수수료',
                children: [
                    { id: 'partner_fee_to_head', label: '협력사 → 본사', page: 'partner_fee_to_head' },
                    { id: 'rider_fee_to_supplier', label: '라이더 → 협력사', page: 'rider_fee_to_supplier' },
                ],
            },
        ],
    },
    {
        id: 'settlement',
        label: '정산',
        icon: 'fa-calculator',
        submenu: [
            { id: 'rider_work_status', label: '라이더 근무 현황', page: 'rider_work_status' },
            {
                id: 'settlement_history',
                label: '정산내역',
                children: [
                    { id: 'transaction_history', label: '입출금내역', page: 'transaction_history' },
                    { id: 'rider_history_week', label: '라이더 주정산내역', page: 'rider_history_week' },
                    { id: 'rider_history_pre', label: '라이더 선정산내역', page: 'rider_history_pre' },
                    { id: 'partner_settlement', label: '협력사 주정산내역', page: 'partner_settlement' },
                ],
            },
            {
                id: 'deduction',
                label: '일차감',
                children: [
                    { id: 'deduction_partner_to_head', label: '협력사 → 본사', page: 'deduction_partner_to_head' },
                    { id: 'deduction_rider_to_head', label: '라이더 → 본사', page: 'deduction_rider_to_head' },
                    { id: 'deduction_rider_to_supplier', label: '라이더 → 협력사', page: 'deduction_rider_to_supplier' },
                ],
            },
            {
                id: 'promotion',
                label: '프로모션',
                children: [
                    { id: 'promotion_head_to_supplier', label: '본사 → 협력사', page: 'promotion_head_to_supplier' },
                    { id: 'promotion_head_to_rider', label: '본사 → 라이더', page: 'promotion_head_to_rider' },
                    { id: 'promotion_supplier_to_rider', label: '협력사 → 라이더', page: 'promotion_supplier_to_rider' },
                ],
            },
        ],
    },
    {
        id: 'system',
        label: '시스템 관리',
        icon: 'fa-cogs',
        submenu: [
            { id: 'settlement_upload', label: '정산서 업로드', page: 'settlement_upload' },
            { id: 'user_management', label: '사용자 관리', page: 'user_management' },
            { id: 'withdraw_request', label: '탈퇴 요청 관리', page: 'withdraw_request' },
            { id: 'virtual_account', label: '가상계좌 관리', page: 'virtual_account' },
            { id: 'withdrawal_restriction', label: '출금 제한', page: 'withdrawal_restriction' },
            { id: 'transfer_management', label: '송금 관리', page: 'transfer_management' },
            { id: 'maintenance_management', label: '점검 관리', page: 'maintenance_management' },
            { id: 'common_code', label: '공통코드 관리', page: 'common_code' },
            { id: 'authority_management', label: '권한 설정', page: 'authority_management' },
            { id: 're_settlement', label: '재마감 관리', page: 're_settlement', disabled: true },
        ],
    },
];
